
export function weekIsBefore(queryYear: number, queryMonth: number, queryWeek: number,
                            compareYear: number, compareMonth: number, compareWeek: number): boolean {
    return queryYear < compareYear
            || (queryYear === compareYear
                && (queryMonth < compareMonth
                    || (queryMonth === compareMonth
                        && queryWeek < compareWeek)));
}


export function weekIsAfter(queryYear: number, queryMonth: number, queryWeek: number,
                            compareYear: number, compareMonth: number, compareWeek: number): boolean {
    return queryYear > compareYear
            || (queryYear === compareYear
                && (queryMonth > compareMonth
                    || (queryMonth === compareMonth
                        && queryWeek > compareWeek)));
}


export function weekIsSame(queryYear: number, queryMonth: number, queryWeek: number,
                            compareYear: number, compareMonth: number, compareWeek: number): boolean {
    return queryYear === compareYear && queryMonth === compareMonth && queryWeek === compareWeek;
}

export function weekCompare(queryYear: number, queryMonth: number, queryWeek: number,
                            compareYear: number, compareMonth: number, compareWeek: number): number {
    if (weekIsSame(queryYear, queryMonth, queryWeek, compareYear, compareMonth, compareWeek))
        return 0;
    else if (weekIsBefore(queryYear, queryMonth, queryWeek, compareYear, compareMonth, compareWeek))
        return -1;
    else
        return 1;
}
